import styled from 'styled-components';
import { AppColors } from '../../../constants';

export const Label = styled.label`
  color: ${(props) => props.color};
  background: ${AppColors.Gray93};
  display: block;
  width: 100%;
  min-height: 31px;
  margin-bottom: 1px;
  padding: 8px;
  font-size: 12px;
  line-height: 15px;
  text-align: left;
  clear: both;
  font-family: Arial;
`;

export const SelectField = styled.select`
  width: 100%;
  height: 31px;
  font-family: Arial;
  font-size: 12px;
  color: ${AppColors.Gray};
  background-color: ${(props) =>
    props.$background ? AppColors.LightPink : AppColors.White};
  padding: 8px;
  border: 1px solid lightgray;
  margin-bottom: 2px;
  border: ${(props) => (props.$borderColor ? '1px solid red' : '')};
`;

export const ErrorContainer = styled.div`
  color: ${AppColors.Red};
`;
